import api from '@/api';

const { $commission, $pricing, $core} = api;

export const { $payings, $sellers } = $commission;
export const { $types } = $pricing
export const { $users } = $core

